import { ArrowLeft, ArrowRight } from "lucide-react";
import type { ComponentPropsWithoutRef } from "react";

const iconClass = "size-4 shrink-0";

type IconLinkProps = ComponentPropsWithoutRef<"span"> & {
  direction?: "forward" | "back";
};

export function IconLink({
  children,
  direction = "forward",
  className = "",
  ...props
}: IconLinkProps) {
  const Icon = direction === "back" ? ArrowLeft : ArrowRight;

  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`} {...props}>
      {direction === "back" && <Icon className={iconClass} strokeWidth={1.75} aria-hidden />}
      {children}
      {direction === "forward" && <Icon className={iconClass} strokeWidth={1.75} aria-hidden />}
    </span>
  );
}
